import { getCurrentSite, getSiteConfig, Site } from './site-config'

const baseURLTest = 'https://interface-test.voghion.com' //测试
const baseURLGray = 'https://interface-gray.voghion.com' //灰度
const baseURLProd = 'https://interface.voghion.sg' //线上

const otherSiteApiSubdomain = 'interface-api'

const envTest = 'test'
const envPre = 'pre'
const envGray = 'gray'

export const envProd = 'prod'

const domainEnvs = [envTest, envPre, envGray]
const envPrefix = 'env-'

export function getAppEnv() {
  if (process.env.NODE_ENV !== 'production') {
    return envTest
  }
  // 从域名获取环境
  const hostname = location.hostname
  const subname = hostname.split('.')[0]
  if (subname.includes('-')) {
    const tag = subname.split('-')[1]
    if (domainEnvs.includes(tag)) {
      return tag
    }
  }
  // 从路径获取环境
  const pathname = location.pathname
  if (pathname.startsWith(`/${envPrefix}`)) {
    const arr = pathname.split('/')
    const env = arr[1].replace(envPrefix, '')
    return env
  }
  return envProd
}

export function getEnvBaseURL() {
  const appEnv = getAppEnv()
  switch (appEnv) {
    case envTest:
      return baseURLTest
    case envGray:
      return baseURLGray
  }
  const site = getCurrentSite()
  if (site === Site.Voghion) {
    return baseURLProd
  }
  const siteConfig = getSiteConfig(site)
  return `https://${otherSiteApiSubdomain}.${siteConfig.mainDomain}`
}

export function isEnvProd() {
  return getAppEnv() === envProd
}

export function isEnvTest() {
  return getAppEnv() === envTest
}

export function isEnvGray() {
  return getAppEnv() === envGray
}
